module.exports = __webpack_public_path__ + "img/parking_green.6321d60d.png";